import { useState } from "react";

export default function PhotoCard({
  photo,
  index,
  isFirst,
  isLast,
  onUpdateLegende,
  onRemove,
  onMoveUp,
  onMoveDown,
}) {
  const [editing, setEditing] = useState(false);
  const [tempLegende, setTempLegende] = useState(photo.legende || "");

  const saveLegende = () => {
    onUpdateLegende(tempLegende);
    setEditing(false);
  };

  return (
    <div className="group bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-md transition-all">
      {/* Thumbnail */}
      <div className="h-36 bg-slate-100 relative">
        {photo.thumbnail_url ? (
          <img
            src={photo.thumbnail_url}
            alt={photo.legende || photo.filename_original}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <svg
              className="w-12 h-12 text-slate-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        )}

        {/* Order badge */}
        <span className="absolute top-2 left-2 w-6 h-6 rounded-full bg-white/90 text-xs font-bold flex items-center justify-center text-slate-700 shadow-sm">
          {index + 1}
        </span>

        {/* Action buttons */}
        <div className="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition">
          <button
            onClick={onMoveUp}
            disabled={isFirst}
            className="w-6 h-6 rounded bg-white/90 shadow-sm flex items-center justify-center text-slate-500 hover:text-slate-800 disabled:opacity-30"
          >
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
            </svg>
          </button>
          <button
            onClick={onMoveDown}
            disabled={isLast}
            className="w-6 h-6 rounded bg-white/90 shadow-sm flex items-center justify-center text-slate-500 hover:text-slate-800 disabled:opacity-30"
          >
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <button
            onClick={onRemove}
            className="w-6 h-6 rounded bg-red-500/90 shadow-sm flex items-center justify-center text-white hover:bg-red-600"
          >
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Info */}
      <div className="p-3 space-y-2">
        <p className="text-xs text-slate-500 truncate">{photo.filename_original}</p>
        {editing ? (
          <div className="flex gap-1">
            <input
              autoFocus
              className="flex-1 text-sm border border-carex-300 rounded px-2 py-1 focus:ring-1 focus:ring-carex-500 outline-none"
              value={tempLegende}
              onChange={(e) => setTempLegende(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") saveLegende();
                if (e.key === "Escape") setEditing(false);
              }}
              placeholder="Ajouter une légende..."
            />
            <button
              onClick={saveLegende}
              className="px-2 py-1 bg-carex-600 text-white rounded text-xs"
            >
              OK
            </button>
          </div>
        ) : (
          <button
            onClick={() => {
              setTempLegende(photo.legende || "");
              setEditing(true);
            }}
            className="w-full text-left text-sm text-slate-700 hover:text-carex-600 transition"
          >
            {photo.legende || (
              <span className="text-slate-400 italic">+ Ajouter une légende</span>
            )}
          </button>
        )}
        <div className="flex items-center justify-between">
          <span className={`text-xs px-1.5 py-0.5 rounded ${
            photo.categorie === "exterieur"
              ? "bg-green-100 text-green-700"
              : photo.categorie === "alentours"
              ? "bg-amber-100 text-amber-700"
              : "bg-carex-100 text-carex-700"
          }`}>
            {photo.categorie === "exterieur" ? "Extérieur" : photo.categorie === "alentours" ? "Alentours" : "Intérieur"}
          </span>
          <span className="text-xs text-slate-400">
            {(photo.taille_octets / 1024 / 1024).toFixed(1)} Mo
          </span>
        </div>
      </div>
    </div>
  );
}
